import React, { FC } from 'react'
import styles from './DocumentEditorWrapper.module.scss'
import { DocumentEditorWrapperProps } from './DocumentEditorWrapper.model'

export const DocumentEditorWrapper: FC<DocumentEditorWrapperProps> = ({ children }) => (
  <div className={styles.container}>
    <div className={styles.editor}>{children}</div>
  </div>
)
